export const POLLING_INTERVAL = 1000;
export const RECOMMENDATION_GENERATION_PLANTING_RATE = {
  MIN: 20000,
  MAX: 180000,
  STEP: 1000,
};
export const FIELD_YIELD_DATA_QUERY_KEY = 'fieldYieldData';
export const SEED_DENSITY_RECOMMENDATION_QUERY_KEY = 'seed-density-recommendation';
export const SEED_DENSITY_RECOMMENDATION_DRAFT_QUERY_KEY = 'seed-density-recommendation-draft';
export const REVIEW_AND_DOWNLOAD_CLASS_NAME = 'review-and-download';
